module.exports = __webpack_public_path__ + "static/media/palette.03d64efa.svg";